var map = {
	"./Arabic.png": 6083,
	"./apple.png": 1119,
	"./article-one.png": 80,
	"./article-three.png": 2237,
	"./article-two.png": 3272,
	"./brand-four.png": 6086,
	"./brand-one.png": 9545,
	"./brand-three.png": 5723,
	"./brand-two.png": 2515,
	"./car-icon.png": 3176,
	"./feature-box-1.png": 9907,
	"./feature-box-2.png": 7776,
	"./features-circle-icon.png": 4548,
	"./features-visa-icon.png": 3704,
	"./foundation.png": 2417,
	"./girl-eye.png": 6523,
	"./hay-layt.png": 5420,
	"./hero-home-bg.png": 4789,
	"./home-banner.png": 2150,
	"./libs-styck.png": 3969,
	"./logo.png": 4427,
	"./mada.png": 6065,
	"./master.png": 1815,
	"./monkier.png": 6612,
	"./not-found-product.png": 1137,
	"./p-1.png": 2319,
	"./p-2.png": 2530,
	"./p-3.png": 7792,
	"./p-4.png": 6769,
	"./paypal.png": 102,
	"./pens.png": 5502,
	"./perfione.png": 1337,
	"./phone-addvertisement.png": 4321,
	"./product-description-high-image.png": 2788,
	"./quotes.png": 2698,
	"./vat.png": 7855,
	"./visa.png": 9511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;